import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import ProgressRing from "@/components/ProgressRing";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";

export default function StudentCourses() {
    const [items, setItems] = useState(null);
    useEffect(() => { api.get("/courses").then(r => setItems(r.data.items)); }, []);
    if (!items) return <Skeleton className="h-96 rounded-2xl" />;
    return (
        <div className="space-y-6" data-testid="student-courses-page">
            <div>
                <div className="text-xs uppercase tracking-widest font-bold text-muted-foreground">Learn</div>
                <h1 className="font-display text-3xl lg:text-4xl mt-1">My courses</h1>
            </div>
            {items.length === 0 ? (
                <div className="mx-card p-12 text-center text-sm text-muted-foreground">You haven't been assigned to any courses yet.</div>
            ) : (
                <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {items.map(c => {
                        const pct = c.progress?.percent || 0;
                        return (
                            <Link key={c.id} to={`/student/courses/${c.id}`} className="mx-card overflow-hidden group" data-testid={`student-course-${c.id}`}>
                                <div className="aspect-video overflow-hidden bg-muted relative">
                                    {c.thumbnail_url && <img src={c.thumbnail_url} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />}
                                    <Badge className="absolute top-3 left-3 bg-white/95 text-foreground border-0">{c.level}</Badge>
                                </div>
                                <div className="p-5 flex items-center gap-4">
                                    <div className="flex-1 min-w-0">
                                        <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">{c.category}</div>
                                        <div className="font-bold mt-1 line-clamp-2">{c.title}</div>
                                    </div>
                                    <ProgressRing percent={pct} size={56} color={pct >= 100 ? "#16A34A" : "#726AF0"} trackColor="hsl(var(--border))" />
                                </div>
                            </Link>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
